import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Pager, Selection,
    Export,
    Summary,
    GroupItem,
    TotalItem
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../utils/Utils";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import Box, { Item } from 'devextreme-react/box';
import { showToast, parseDate, showDialog, hasRole, parseApiDate } from "../../utils/Utils";
import CariDonemDomainFinansRapor from "./CariDonemDomainFinansRapor";
import {ToastType} from "../../constants/Constants"; 

import './CariDonemFinansRapor.scss';
import CariDonemDomainFinansOzetRapor from './CariDonemDomainFinansOzetRapor';

const CariDonemFinansRapor = () => {

    const [formYetki, setFormYetki] = useState(
        {
            listele: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|listele"),
            cariDonemRaporDomainListele: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemRaporDomainListele"),
            export: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemExcelExport"),
            cariDonemRaporOzetList: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemRaporOzetList"),
            adminUserListDetail: Utils.hasRole("admin|userListDetail|userListDetail"),
        });


    const listeBasligi = "Cari Donem Finans Rapor İşlemleri";

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [store, setStore] = useState(null);
    const [filterMap, setFilterMap] = useState(null);

    const [adminUserTreeBoxValue, setAdminUserTreeBoxValue] = useState([]);
    const [adminUserTreeDataSource, setAdminUserTreeDataSource] = useState([]);


    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);
    const [cariDonemRaporDomainPopupForm, setCariDonemRaporDomainPopupForm] = useState({ popupState: false });
    const [cariDonemOzetRaporDomainPopupForm, setCariOzetDonemRaporDomainPopupForm] = useState({ popupState: false });

    useEffect(() => {
        setFilterMap(Utils.getFilterMap(dataGrid));
    }, [])

    useEffect(() => {
        if (filterMap) {
            domainListYukle();
            donemListYukle();
            adminUserTreeDatasourceYukle();
            setStore(getStore());
        }
    }, [filterMap])

    useEffect(() => {
        if (adminUserTreeBoxValue) { 
            domainListYukle(); 
        }
    }, [adminUserTreeBoxValue])

    const domainListYukle = () => {

        let url = "/userDomain/getUserDomainList";


        if(adminUserTreeBoxValue.length >0){
            url = "/userDomain/getUserDomainList/" +adminUserTreeBoxValue[0];
        }
        const request = new Request(url, "GET");

       

        request.run()
            .then(response => {
                if (response.data) {

                    let  tumu ={
                        "id":-1,
                        "name": "Tümü",
                        "parent":null
                    };
                    let array = [tumu];
                    response.data.data.map(d => {
                        if (d.parent == null) {
                            d.parent = tumu;
                            array.push(d);
                        }
                    });

                    setTreeDataSource(array);
                } else {
                    return []

                }
            });
    }

    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime()) {
                            datas.push(d);
                        }
                    });
                    // datas.sort((a,b) =>
                    //     a.tarih.getTime() - b.tarih.getTime()
                    // ).reverse();
                    // debugger;
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) == -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();


                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });

                    setTreeDataDonemSource(datas);
                } else {
                    return []
                }
            });
    }

    const adminUserTreeDatasourceYukle = () => {

        const request = new Request("/userDomain/getUserCustomDtoListSession", "GET");

        request.run()
            .then(response => { 
                if (response.data && response.data.data) { 

                    setAdminUserTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }


    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;
    let adminUserTreeView = null;

    const getStore = () => {
        let tempGrid = dataGrid;

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                let filterArr = [];
                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "dm.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }

                if (treeBoxDonemValue.length > 0) {
                    filterArr.push({
                        property: "donem.id",
                        operator: "IN",
                        value: treeBoxDonemValue,
                        type: "Long"
                    })
                }else  {
                    showToast('Dönem seçiniz', ToastType.ERROR, 500);
                    return []
                }

                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);


                if (tempGrid != null && tempGrid.instance != null) {
                    tempGrid.instance.clearSelection();
                }

                const request = new Request("/cariDonemFinansRapor/getKayitList" + params, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            response.data.data.map(d => {
                                if (d.hesapToplamFark == null) {
                                    d.hesapToplamFark = 0;
                                }
                            });


                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }


    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const syncAdminUserTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (adminUserTreeView && adminUserTreeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || adminUserTreeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setAdminUserTreeBoxValue([]);
            } else {
                setAdminUserTreeBoxValue(e.value);
            }
        }
    }

    const adminUserTreeViewRender = () => {
        return (
            <TreeView dataSource={adminUserTreeDataSource}
                ref={(ref) => adminUserTreeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parentId"
                selectionMode="single"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncAdminUserTreeViewSelection}
                onItemSelectionChanged={adminUserTreeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const adminUserTreeView_itemSelectionChanged = (e) => {
        setAdminUserTreeBoxValue(e.component.getSelectedNodeKeys());
    }


    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    }

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    }

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    }

    const yenile = () => {
        setStore(getStore());
    }

    const openDetayForm = () => {
        let data = { cariDonemRaporIdList: [] };

        dataGrid.instance.getSelectedRowsData().map(sd => {
            data.cariDonemRaporIdList.push(sd.id);
        });

        setCariDonemRaporDomainPopupForm({ popupState: true, data: data })
    }

    function hideCariDonemRaporDomainPopupForm() {
        setCariDonemRaporDomainPopupForm({ popupState: false })
        yenile();
    }

    function showOzetPopup(data) {

        setCariOzetDonemRaporDomainPopupForm({ popupState: true, data: data })     
    }
    function hideCariOZetDonemRaporDomainPopupForm() {
        setCariOzetDonemRaporDomainPopupForm({ popupState: false }) 
    }

    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                {formYetki.adminUserListDetail ?  <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={adminUserTreeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Kullanıcı Seçiniz..."
                                showClearButton={true}
                                dataSource={adminUserTreeDataSource}
                                onValueChanged={syncAdminUserTreeViewSelection}
                                contentRender={adminUserTreeViewRender}
                            />
                        </Item>
                    </Box>: null
                    
                }
               

                    <Box direction="row" width={400} height={25}>
                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={treeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Firma Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataSource}
                                onValueChanged={syncTreeViewSelection}
                                contentRender={treeViewRender}
                            />
                        </Item>
                    </Box>
                    <Box direction="row" width={400} height={25}>

                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={treeBoxDonemValue}
                                valueExpr="id"
                                displayExpr="donem"
                                placeholder="Dönem Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataDonemSource}
                                onValueChanged={syncTreeViewDonemSelection}
                                contentRender={treeViewDonemRender}
                            />
                        </Item>

                    </Box>
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" ,marginTop:"5px"}}
                        onClick={yenile}></Button>
                    <Button icon="plus" width={150} text="Detay görüntüle" type={'success'} style={{ fontSize: "15px",marginTop:"5px",marginLeft:"10px" }}
                        onClick={openDetayForm} visible={formYetki.cariDonemRaporDomainListele}></Button>

                </div>
            </div>

            <DataGrid
                className="cariDonemFinansRaporGrid"

                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                
                //remoteOperations={true}
            >
                 <Export enabled={true} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={200} />
                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[12, 24, 36, 48, 60, 100, 200]} showInfo={true} visible={true} /> */}
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />
                {/* <GroupPanel visible={true} />
                <Grouping autoExpandAll={true} /> */}
                {/* <Paging enabled={false} /> */}

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        { 
                            hint: 'Cari Donem Personel Detay', 
                            icon: 'alignjustify', 
                            visible: () => { return formYetki.cariDonemRaporOzetList },
                            onClick: (e) => { showOzetPopup(e.row.data); } 
                        },
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="nuber" visible={false} />
                <Column dataField={'domain.name'} width={450} caption={'Domain'} dataType="string" visible={true} mappingField="dm.name" />
                <Column dataField={'domain.sozlesmeli'} width={50} caption={'Sozlesme'} dataType="boolean" mappingType="bool" visible={true} mappingField="dm.sozlesmeli" />
                <Column dataField="donem.donem" width={90} caption={'Dönem'} dataType="string" visible={true}
                    defaultSortOrder="desc"
                    mappingField="donem.donem"
                />
                <Column dataField={"hesapToplamFark"} width={90} caption={'Fark'} dataType="number" mappingType="int" visible={true} />

                <Column dataField={'hesapFaturaTutar'} width={90} caption={'Fatura Tutar'} dataType="number" mappingType="int" visible={true} />
                <Column dataField={'kullaniciFaturaTutar'} width={100} caption={'Kullanıcı Fatura Tutar'} dataType="int" visible={true} />

                <Column dataField={'anlasmaOran'} width={100} caption={'Anlaşma Oran'} dataType="int" visible={false} />
                <Column dataField={'anlasmaTutar'} width={100} caption={'Anlaşma Tutar'} dataType="int" visible={false} />

                <Column dataField={'ariIkOran'} width={100} caption={'Ari-ik Oran'} dataType="int" visible={false} />
                <Column dataField={'ariIkTutar'} width={100} caption={'Ari-ik Tutar'} dataType="int" visible={false} />
                <Column dataField={'kullaniciFaturaAciklama'} width={450} caption={'Açıklama'} dataType="string" visible={true} />
           
                <Column dataField={"hesapToplamTesvikRakami"} width={90} caption={'Teşvik Toplam(%5 hariç)'} dataType="number" mappingType="int" visible={true} />
                <Column dataField={"hesapToplamPrimDestegiYude5"} width={90} caption={'Toplam %5 Tutar'} dataType="number" mappingType="int" visible={true} />
                <Column dataField={"hesapToplamVergiTutari"} width={90} caption={'Topalm Vergi'} dataType="number" mappingType="int" visible={true} />
                <Summary  > 
                    <TotalItem
                        column="hesapFaturaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                    <TotalItem
                        column="kullaniciFaturaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                    <TotalItem
                        column="ariIkTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                   
                   <TotalItem
                        column="hesapToplamTesvikRakami"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />

                    <TotalItem
                        column="hesapToplamPrimDestegiYude5"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />

                    <TotalItem
                        column="hesapToplamVergiTutari"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                </Summary>
            </DataGrid>


            <Popup
                visible={cariDonemRaporDomainPopupForm.popupState}
                onHiding={hideCariDonemRaporDomainPopupForm}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Cari Dönem Finans Rapor Formu"
                width={900}
                height={560}
            >
                <div>
                    {cariDonemRaporDomainPopupForm.popupState ? <CariDonemDomainFinansRapor hide={hideCariDonemRaporDomainPopupForm} data={cariDonemRaporDomainPopupForm.data} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideCariDonemRaporDomainPopupForm}
                    />
                </div>
            </Popup>

            <Popup
                visible={cariDonemOzetRaporDomainPopupForm.popupState}
                onHiding={hideCariOZetDonemRaporDomainPopupForm}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Cari Dönem Özet Finans Rapor Formu"
                width={900}
                height={560}
            >
                <div>
                    {cariDonemOzetRaporDomainPopupForm.popupState ? <CariDonemDomainFinansOzetRapor hide={hideCariOZetDonemRaporDomainPopupForm} data={cariDonemOzetRaporDomainPopupForm.data} dataType={"finansRapor"} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideCariOZetDonemRaporDomainPopupForm}
                    />
                </div>
            </Popup>

        </React.Fragment>
    );
}

export default CariDonemFinansRapor;
